import { AccountManagerSelector } from 'shared/components';

import { useExternalMailActionFormContext } from './form-context';

export const ExternalMailActionAccountManager = () => {
  const form = useExternalMailActionFormContext();

  return (
    <AccountManagerSelector
      value={form.values.userId}
      onChange={value => form.setFieldValue('userId', value)}
    />
  );
};
